import Vue from "vue";
import ApiService from "../../../../../services/api";
import moment from "moment";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";

export default {
	props: {
		filters: Array,
		reportName: String
	},
	data: function() {
		return {
			alarmsTitle: "Confronto periodo attuale vs precedente",
			//#region chart
			alarms: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#ffdf00",
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light",
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#ff8300",
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light",
					}
				}
			],
			alarmsData: [],
			alarmsCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					// rotation: {
					// 	angle: 45,
					// 	align: "end"
					// },
					font: "10px montserrat-light"
				}
			},
			alarmsTooltip: {
				visible: true,
				template: this.getTooltip
			},
			alarmsValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						//content: this.getTimeFromString,
						visible: false
					}
				}
			],

			alarmsChartIndex: 0,
			//#endregion

			//#region MODAL CHART
			alarmsModalShow: false,
			alarmsChartTitle: "CONFRONTO PERIODO ATTUALE VS. PRECEDENTE",
			alarmsChartModalIndex: 0,

			alarmsChartPdfOptions: {
				landscape: true,
				fileName: "allarmi",
				title: "ALLARMI"
			},

			alarmsChartValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "NR",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						//content: this.getTimeFromString,
						visible: true,
						font: "13px montserrat-light"
					}
				}
			],

			alarmsChartLegend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var color = e.series.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
							fill: {
								color: labelColor
							},
							font: "12px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},
			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles"
			//#endregion MODAL CHART
		};
	},
	created() {
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
	},
	mounted() {
		this.getData();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.getData();
		},
		modalChartClickHandler() {
			var self = this;

			self.alarmsModalShow = true;
			setTimeout(() => {
				self.alarmsChartModalIndex++;
			}, 200);
		},
		getStackTimeFromString(e) {
			return kendo.toString(e.stackValue, "n0");
		},
		getTooltip(e) {
			if (e.series.field == "current") {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.from} al ${e.dataItem.to}: ${e.dataItem.current}</span>`;
			} else {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.previousfrom} al ${e.dataItem.previousto}: ${e.dataItem.previous}</span>`;
			}
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;
						default:
							break;
					}
				});
			}

			return data;
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getAlarmsChartReport(data).then(res => {
				var currentData = res;

				var timesFilter = self.filters.find(item => {
					return item.id == "timerange";
				});

				var startDate = moment(timesFilter.value.startRange);
				var endDate = moment(timesFilter.value.endRange);
				var diffDay = endDate.diff(startDate, "days") + 1;

				var newStartDate = moment(startDate).add(-diffDay, "days");
				var newEndDate = moment(newStartDate)
					.add(diffDay, "days")
					.add(-1, "minutes");

				data["dateRange.From"] = moment(newStartDate)
					.utc()
					.format();
				data["dateRange.To"] = moment(newEndDate)
					.utc()
					.format();

				ApiService.getAlarmsChartReport(data).then(res => {
					var currentFromDate = self.$options.filters.dateToString(startDate);
					var currentEndDate = self.$options.filters.dateToString(endDate);

					var previousFromDate = self.$options.filters.dateToString(newStartDate);
					var previousEndDate = self.$options.filters.dateToString(newEndDate);
					self.setAlarmData(currentData, currentFromDate, currentEndDate, res, previousFromDate, previousEndDate);

					self.$emit("on-loading", false);
				});
			});
		},
		setAlarmData(currentData, currentFromDate, currentEndDate, previousData, previousFromDate, previousEndDate) {
			var self = this;

			var previousItems = previousData[0].values;
			self.alarmsData = [];
			self.alarmsCategoryAxis.categories = [];

			self.alarmsTitle = `Confronto periodo da ${previousFromDate} a ${currentEndDate}`;
			let reportName = "Conteggio_allarmi";
			if (this.reportName) {
				reportName = this.reportName.replace(/[ ]/g, "_");
			}
			self.alarmsChartPdfOptions.fileName = helpers.chartPdffileName(this, reportName, moment(previousFromDate, "DD/MM/YYYY"), moment(currentEndDate, "DD/MM/YYYY"));
			self.alarmsData = [];

			for (var prop in previousItems) {
				var category = prop;
				var displayedCategory = prop.toUpperCase();

				self.alarmsCategoryAxis.categories.push(displayedCategory.replace(/ /g, "\n"));

				self.alarmsData.push({
					from: currentFromDate,
					to: currentEndDate,
					previousfrom: previousFromDate,
					previousto: previousEndDate,
					name: category,
					current: 0,
					previous: previousItems[prop]
				});
			}

			var currentItems = currentData[0].values;

			for (var prop in currentItems) {
				var category = prop;
				var displayedCategory = prop.toUpperCase().replace(/ /g, "\n");

				var inserted =
					self.alarmsCategoryAxis.categories.findIndex(item => {
						return item == displayedCategory;
					}) >= 0;

				if (inserted == false) {
					self.alarmsCategoryAxis.categories.push(displayedCategory);
				}

				var currentItem = self.alarmsData.find(item => {
					return item.name == category;
				});

				var value = currentItems[prop];

				if (currentItem) {
					currentItem.current = value ? value : 0;
				} else {
					self.alarmsData.push({
						from: currentFromDate,
						to: currentEndDate,
						previousfrom: previousFromDate,
						previousto: previousEndDate,
						name: category,
						current: value ? value : 0,
						previous: 0
					});
				}
			}

			self.alarmsChartIndex++;
		},
		//#region Modal
		//Modal
		exportAsXlsx(type) {
			var self = this;

			var data = this.getRequestData();
			if (type == 'csv') data['format'] = 'csv';

			ApiService.exportChartXlsx("alarms-counter", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `allarmi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},

		exportAsPdf() {
			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				transitions: false,

				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},
		createChart(container, exportOptions) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.alarmsChartPdfOptions,
				theme: "metro",
				title: {
					text: self.alarmsTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				series: [
					{
						name: "Periodo precedente",
						field: "previous",
						color: "#ffdf00",
						labels: {
							visible: true,
							template: this.getStackTimeFromString,
							background: "none",
							font: "13px montserrat-light",
						}
					},
					{
						name: "Periodo attuale",
						field: "current",
						color: "#ff8300",
						labels: {
							visible: true,
							template: this.getStackTimeFromString,
							background: "none",
							font: "13px montserrat-light",
						}
					}
				],
				dataSource: {
					data: self.alarmsData
				},
				valueAxis: self.alarmsChartValueAxisModal,
				categoryAxis: {
					categories: self.alarmsCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light",
						// rotation: {
						// 	angle: 45,
						// 	align: "end"
						// }
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			$(container).kendoChart(options);
		}
		//#endregion modal
	},
	computed: {
		...mapGetters(["settings"]),
	}
};
